"use client";

import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        {[1, 2, 3, 4].map((_, i) => <div key={i} className="h-4 w-20 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="hidden md:flex">
      <NavigationMenuList className="gap-8">
        {menuItems.map(item => <NavigationMenuItem key={item.id}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "/"} className="text-base font-default text-foreground/70 hover:text-primary transition-all duration-300 hover:translate-y-[-1px] tracking-wide">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer({
  isOpen
}: {
  isOpen: boolean;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (!isOpen || loading) return null;
  return <div className="md:hidden border-t border-border bg-background/98 backdrop-blur-xl animate-in slide-in-from-top-4 duration-300">
      <nav className="flex flex-col p-8 space-y-6">
        {menuItems.map(item => <Link key={item.id} to={item.href || "/"} className="text-xl font-default text-foreground/80 hover:text-primary transition-colors">
            {item.label}
          </Link>)}
        <Button asChild className="w-full rounded-lg h-14 text-lg">
          <Link to="#">Gespräch vereinbaren</Link>
        </Button>
      </nav>
    </div>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="header" className={cn("sticky top-0 z-50 w-full transition-all duration-500 ease-in-out", isScrolled ? "bg-background/90 backdrop-blur-md border-b border-border shadow-sm h-20" : "bg-background h-28")}>
      <div className="container mx-auto h-full px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-full">
          
          <div className="flex-shrink-0">
            <Link to="/" className="block group">
              <img src="https://praxis-soonwald.de/wp-content/uploads/2026/04/5.-Psychologie.svg" alt="Psychologische Praxis Soonwald" className={cn("w-auto transition-all duration-500 ease-in-out group-hover:scale-105", isScrolled ? "h-24" : "h-32")} />
            </Link>
          </div>

          <div className="hidden md:flex flex-1 justify-center">
            <MenuProvider menu_id="41">
              <HeaderMenuConsumer />
            </MenuProvider>
          </div>

          <div className="flex items-center gap-6">
            <Button asChild className="hidden sm:inline-flex rounded-lg px-8 bg-primary text-primary-foreground hover:shadow-lg hover:shadow-primary/20 transition-all duration-300 h-11">
              <Link to="#">Gespräch vereinbaren</Link>
            </Button>
            
            <Button variant="ghost" size="icon" className="md:hidden text-foreground hover:text-primary transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Menü öffnen">
              {isMobileMenuOpen ? <X className="size-7" /> : <Menu className="size-7" />}
            </Button>
          </div>
        </div>
      </div>

      <MenuProvider menu_id="41">
        <MobileMenuConsumer isOpen={isMobileMenuOpen} />
      </MenuProvider>
    </section>;
}